module.exports = __webpack_public_path__ + "static/img/professional.260584e1.svg";